import {AppLayout} from "../layout/AppLayout.tsx";
import {AuthorizePage} from "../features/oauth2/pages/AuthorizePage.tsx";
import {Navigate} from "react-router-dom";
import {IndexPage} from "../features/home/pages/IndexPage.tsx";
import {AccountsLayout} from "../features/accounts/layout.tsx";
import SignInProfilesLayout from "../features/sign-in-profiles/layout.tsx";
import {IndexPage as AboutPage} from "../features/about/pages/IndexPage.tsx";
import {IndexPage as ApplicationsPage} from "../features/applications/pages/IndexPage.tsx";
import {
    ApplicationErrorPage,
    PageNotFoundPage
} from "@pac/platform-ui-components";

export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <IndexPage/>,
    }, {
        path: '/login',
        element: <Navigate to="/redirect"/>,
    }, {
        path: '/accounts/*',
        element: <AccountsLayout/>,
    }, {
        path: '/applications/*',
        element: <ApplicationsPage/>,
    }, {
        path: '/sign-in-profiles/*',
        element: <SignInProfilesLayout/>,
    }, {
        path: '/oauth2/authorize/*',
        element: <AuthorizePage/>,
    }, {
        path: '/about',
        element: <AboutPage/>,
    }, {
        path: '/offline',
        element: <PageNotFoundPage message={'You are offline'}/>,
    }, {
        path: '404',
        element: <PageNotFoundPage/>,
    }, {
        path: '*',
        element: <PageNotFoundPage/>,
    }],
}]